module.exports = __webpack_public_path__ + "static/img/112.d3168577.png";